import {NatGetLifeNoteList} from './NatGetLifeNoteList'
import {NatGetLifeNote} from './NatGetLifeNote'
import {NatPostLifeNote, NatPostLifeNoteParams} from './NatPostLifeNote'
import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants';
import {NatPutLifeNote, NatPutLifeNoteParam} from './NatPutLifeNote';
import {NatDeleteLifeNote} from './NatDeleteLifeNote';

export default class NatLifeNoteRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 生活便利帳一覧取得
    async getLifeNoteList(searchCondition?: string): Promise<NatGetLifeNoteList> {
        return await this.http.get(`/api/common/lifeNote/?${searchCondition}`);
    }

    // 生活便利帳取得
    async getLifeNote(lifeNoteId: string): Promise<NatGetLifeNote> {
        return await this.http.get(`/api/common/lifeNote/${lifeNoteId}`);
    }

    // 生活便利帳削除
    async deleteLifeNote(lifeNoteId: string): Promise<NatDeleteLifeNote> {
        return await this.http.delete(`/api/admin/lifeNote/${lifeNoteId}`);
    }

    // 生活便利帳登録
    async postLifeNote(request: NatPostLifeNoteParams): Promise<NatPostLifeNote> {
        return await this.http.post(`/api/admin/lifeNote`, {
                condominiumGroupId: request.condominiumGroupId,
                deliveryTargetPrefectureCd: request.deliveryTargetPrefectureCd,
                deliveryTargetAddress2: request.deliveryTargetAddress2,
                lifeNoteNotDeliveryCondominium: request.lifeNoteNotDeliveryCondominium,
                categoryId: request.categoryId,
                title: request.title,
                description: request.description,
                publishStartDate: request.publishStartDate,
                publishEndDate: request.publishEndDate,
                sortOrder: request.sortOrder,
                url: request.url,
                targetAttr: request.targetAttr,
                lifeNoteFileName: request.lifeNoteFileName,
                lifeNoteFileData: request.lifeNoteFileData,
            }, ContentType.JSON,
        )
    }

    // 生活便利帳更新
    async putUpdateLifeNote(request: NatPutLifeNoteParam): Promise<NatPutLifeNote> {
        return await this.http.put(`/api/admin/lifeNote`, request);
    }

}
